import React from 'react';
import DatePickerAtom from 'react-datepicker';
import classNames from 'classnames';

import 'react-datepicker/dist/react-datepicker.css';

import '../../Atoms/DatePicker/date-picker.scss';

// Month labels for the header
const months = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December'
];

// Simple range helper
function range(start, end, step = 1) {
  const out = [];
  for (let i = start; i < end; i += step) out.push(i);
  return out;
}

// Years: 1935 → current year (inclusive)
const years = range(1935, new Date().getFullYear() + 1);


const DatePicker = ({
  fullWidth,
  title,
  name,
  onChange,
  formValid,
  value,
  style = {},
  renderCustomHeader: renderCustomHeaderProp,
  ...rest
}) => {
  const inputClass = classNames('custom-input', {
    'full-width': fullWidth,
  });

  const setDate = (date) => {
    onChange({ target: { name, value: date } });
  };

  // return (
  //   <div className="custom-datepicker" style={style}>
  //     <div className={inputClass}>
  //       {title && <label>{title}</label>}
  //       <DatePickerAtom {...rest} selected={value} onChange={setDate} />
  //     </div>
  //   </div>
  // );


  // Our default custom header (can be overridden via prop)
  const defaultRenderCustomHeader = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => {
    const safeDate = date instanceof Date ? date : new Date();
    const selectedMonthIndex = safeDate.getMonth();
    const selectedYear = safeDate.getFullYear();

    return (
      <div className="dp-custom-header">
        <button
          type="button"
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
          aria-label="Previous month"
          className="dp-nav-btn"
        >
          {'<'}
        </button>

        <div className="dp-header-controls">
          <select
            className="dp-month"
            value={months[selectedMonthIndex]}
            onChange={(e) => changeMonth(months.indexOf(e.target.value))}
            aria-label="Select month"
          >
            {months.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>

          <select
            className="dp-year"
            value={selectedYear}
            onChange={(e) => changeYear(Number(e.target.value))}
            aria-label="Select year"
          >
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </div>

        <button
          type="button"
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
          aria-label="Next month"
          className="dp-nav-btn"
        >
          {'>'}
        </button>
      </div>
    );
  };

  return (
    <div className="custom-datepicker" style={style}>
      <div className={inputClass}>
        {title && <label>{title}</label>}

        <DatePickerAtom
          {...rest}
          selected={value}
          onChange={setDate}
          // use caller's header if provided; otherwise our default
          renderCustomHeader={renderCustomHeaderProp ?? defaultRenderCustomHeader}
          // optional: keep keyboard nav sane and selects snappy
          // dropdownMode="select"
          // showPopperArrow={false}
        />
      </div>
    </div>
  );
};

export default DatePicker;
